import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { style: {"position":"absolute","top":"65px","left":"0","right":"0","bottom":"10px","overflow-y":"scroll"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_main_app_bar = _resolveComponent("main-app-bar")!
  const _component_v_img = _resolveComponent("v-img")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_connection_row = _resolveComponent("connection-row")!
  const _component_v_container = _resolveComponent("v-container")!
  const _component_v_main = _resolveComponent("v-main")!
  const _component_v_app = _resolveComponent("v-app")!

  return (_openBlock(), _createBlock(_component_v_app, null, {
    default: _withCtx(() => [
      _createVNode(_component_main_app_bar, {
        elevation: "2",
        "app-bar-color": "",
        "app-bar-text-color": ""
      }),
      _createVNode(_component_v_main, {
        class: "mainDiv",
        style: _normalizeStyle({ 'background-image': 'url(' + _ctx.baseImg + ')' })
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createVNode(_component_v_container, { fluid: "" }, {
              default: _withCtx(() => [
                _createVNode(_component_v_row, {
                  justify: "center",
                  align: "center"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_col, { class: "mx-auto" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_card, {
                          class: "mx-auto",
                          "min-width": "200",
                          "max-width": "600"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_img, {
                              color: "surface-variant",
                              "min-height": "100",
                              "max-height": "500",
                              style: {"object-fit":"scale-down"},
                              src: _ctx.machine
                            }, null, 8, ["src"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_col, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_card, { style: {"background-color":"#ffffffa0"} }, {
                          default: _withCtx(() => _cache[0] || (_cache[0] = [
                            _createElementVNode("div", {
                              style: {"text-align":"left"},
                              class: "ma-3"
                            }, [
                              _createElementVNode("p", { class: "text-h5 playFairFont" }, [
                                _createTextVNode(" Üdvözöljük oldalunkon, örülünk, hogy ellátogatott hozzánk! "),
                                _createElementVNode("br"),
                                _createTextVNode(" Vállalkozásunk fő profilja a gépi hímzett termékek árusítása , legyen az ruha, táska, párna, sapka,"),
                                _createElementVNode("br"),
                                _createTextVNode(" törölköző!"),
                                _createElementVNode("br"),
                                _createTextVNode(" A hímzett termékek, nem csak egyediek, szépek és elegánsak, de divatosak is egyben. Ünnepre, eseményre,"),
                                _createElementVNode("br"),
                                _createTextVNode(" ajándékként, vagy személyes használatra. A gépi hímzés előnye más technológiával szemben, hogy tartós, nem"),
                                _createElementVNode("br"),
                                _createTextVNode(" fakul ki, nem kopik le."),
                                _createElementVNode("br"),
                                _createTextVNode(" Egyedi elképzelése van? Abban is tudunk segíteni!"),
                                _createElementVNode("br"),
                                _createElementVNode("br")
                              ])
                            ], -1)
                          ])),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_row, {
                  align: "center",
                  justify: "center"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_col, {
                      lg: "8",
                      xs: "12"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_card, { style: {"background-color":"#ffffffa0"} }, {
                          default: _withCtx(() => [
                            _cache[1] || (_cache[1] = _createElementVNode("p", {
                              class: "text-h5 mt-10 queensFont",
                              style: {"text-align":"center"}
                            }, [
                              _createTextVNode(" Keressen minket elérhetőségeink egyikén:"),
                              _createElementVNode("br")
                            ], -1)),
                            _createVNode(_component_connection_row)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ])
        ]),
        _: 1
      }, 8, ["style"])
    ]),
    _: 1
  }))
}